export const blockIconsUiactionsCheckBoxOutlineBlankNew = (
	<span className='material-symbols-outlined'>check_box_outline_blank</span>
);
